module.exports = __webpack_public_path__ + "img/ticket_dark.83ad7d5b.png";